module.exports = __webpack_public_path__ + "57369b70c29535d5fe9dfd500d5407f1.png";